import loadComponents from './tools/tools'
import draggable from 'vuedraggable'
import PortalVue from 'portal-vue'
import { defineWidgets, defineLocalization } from './widgets'
import { defineLayouts } from './layouts/index'
import formio from './formio'
import layouts from './layouts/layouts'
import EventBusVue from 'vue'
import { mask } from 'vue-the-mask'
import eds from '@it-enterprise/digital-signature-ui'

// базовые макеты
export const Layouts = layouts

// шина событий
export const EventBus = new EventBusVue()

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    if (!options) {
      throw new Error('Vue addon parameters not passed')
    }

    let { layouts } = options
    Vue.component('draggable', draggable)
    Vue.use(PortalVue)
    Vue.directive('mask', mask)

    Vue.use(formio, options.formio)

    defineWidgets(Vue)
    defineLayouts(layouts)
    defineLocalization(options.formio.dependencies.i18n)

    loadComponents(require.context('./components', true, /\.vue$/)).forEach(c => Vue.component(c.name, c.component))

    options.eds.ApiUrl += !options.eds.ApiUrl.endsWith('/') ? '/api/ds' : 'api/ds'
    Vue.use(eds, options.eds)
  }
}

